import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { DatePicker, DatePickerProps } from 'antd';
import localeFR from 'antd/es/date-picker/locale/fr_FR';
import localeEN from 'antd/es/date-picker/locale/en_US';
import { DEFAULT_DISPLAY_DATETIME_FORMAT } from '@/config';

export default function AppDateTimePicker({ value, noTimeZone, ...props }: DatePickerProps & { noTimeZone?: boolean }) {
  const { t, i18n } = useTranslation();

  const locale = React.useMemo(() => {
    if (i18n.language === 'fr') {
      return localeFR;
    }
    return localeEN;
  }, [i18n.language]);

  return (
    <DatePicker
      format={DEFAULT_DISPLAY_DATETIME_FORMAT}
      placeholder={t('Select date')}
      {...(props as any)}
      value={value}
      locale={locale}
      inputReadOnly={false}
      showTime={true}
    />
  );
}
